export enum EChannel {
  DIADIA = 2,
  INSUMA = 1,
  ALICORP = 3,
}
